<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useDeviceManagementStore } from '@nsftx/seven-client-retail-vue-dm'

const appBuildHash = `(build ${import.meta.env.VITE_COMMIT_HASH?.trim()})`
const appVersion = import.meta.env.VITE_APP_VERSION

const { appData } = storeToRefs(useDeviceManagementStore())
const deviceInfo = computed(() =>
  appData.value ? `${appData.value.betshop.companyName} | ${appData.value.device.name}` : null,
)
</script>

<template>
  <div class="ss-footer-device-info ss-ml-auto ss-d-flex ss-gap-3xs">
    <div class="ss-footer-device-info__container ss-d-flex-column">
      <span class="ss-footer-device-info__container__primary">
        {{ deviceInfo }}
      </span>
      <span class="ss-footer-device-info__container__secondary">
        {{ appVersion }} {{ appBuildHash }}
      </span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@/styles/mixins' as mixins;

.ss-footer-device-info {
  &__container {
    justify-content: center;

    &__primary {
      @include mixins.typography('label-strong');
      color: var(--nxgds-mapped-color-text-primary);
    }

    &__secondary {
      display: block;
      @include mixins.typography('caption-regular');
      color: var(--nxgds-mapped-color-text-disabled);
    }
  }
}
</style>
